import { useState } from "react";
import api from "../../../api";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layouts/DashboardLayout";
import AvatarPreview from "../../../components/AvatarPreview";
import { Card, CardContent } from "../../../components/ui/CCard";
import { UserCircle } from "lucide-react";


let initialAvatarData = {
    name: "",
    age_group: "",
    avatar_provider: "",
    avatar_id: "",
    gender: ""
};

export default function AvatarNew() {
    const [avatarData, setAvatarData] = useState(initialAvatarData);

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAvatarData((prev) => {
            const updated = { ...prev, [name]: value.replace(".glb", "") };
            console.log("Updated avatarData:", updated);
            return updated;
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        await api.createAvatar(avatarData); // call backend
        navigate("/avatar"); // go back to listing
    };


    return (
        <DashboardLayout>
            {/* Back Button */}
            <div className="mb-4 max-w-4xl mx-auto">
                <button
                    type="button"
                    onClick={() => navigate("/avatar")}
                    className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-800 transition-colors"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    <span className="font-medium">Back to Avatars</span>
                </button>
            </div>

            <div className="max-w-4xl mx-auto bg-white rounded-2xl border border-secondary-100 shadow-sm overflow-hidden">
                <div className="px-6 py-5 border-b border-secondary-100 flex items-center gap-3">
                    <div className="w-9 h-9 bg-primary-100 rounded-xl flex items-center justify-center">
                        <UserCircle className="w-5 h-5 text-primary-600" />
                    </div>
                    <div>
                        <h2 className="text-lg font-bold text-secondary-900">Add New Avatar</h2>
                        <p className="text-xs text-secondary-400">Fields marked <span className="text-red-500">*</span> are required</p>
                    </div>
                </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-4">
                {/* Two-column layout */}
                <div className="flex gap-6">
                    {/* Left side: controls */}
                    <Card className="flex-1">
                        <CardContent className="p-6 space-y-4">
                            <input
                                type="text"
                                name="name"
                                placeholder="Name"
                                value={avatarData.name}
                                onChange={handleChange}
                                className="border px-3 py-2 rounded w-full"
                            />
                            <select 
                                name="age_group" 
                                onChange={handleChange}
                                className="border p-2 w-full" 
                                value={avatarData.age_group} required >
                                    <option value="">Select Age Group</option>
                                    <option>Teen</option>
                                    <option>YoungAdult</option>
                                    <option>Adult</option>
                                    <option>MiddleAged</option>
                                    <option>Senior</option>
                            </select>
                            <select 
                                name="gender" 
                                onChange={handleChange}
                                className="border p-2 w-full" 
                                value={avatarData.gender} required >
                                    <option value="">Select Gender</option>
                                    <option>Male</option>
                                    <option>Female</option>
                            </select>
                            {/* <input
                                type="text"
                                name="avatar_provider"
                                placeholder="Avatar Provider"
                                value={avatarData.avatar_provider}
                                onChange={handleChange}
                                className="border px-3 py-2 rounded w-full"
                            /> */}
                            <input
                                type="text"
                                name="avatar_id"
                                placeholder="Avatar ID"
                                value={avatarData.avatar_id}
                                onChange={handleChange}
                                className="border px-3 py-2 rounded w-full"
                            />
                        </CardContent>
                    </Card>

                    {/* Right side: preview */}
                    <Card className="flex-1">
                        <CardContent className="p-6 flex items-center justify-center">
                            {avatarData.avatar_id ? (
                                <div>
                                    <p><h1>Avatar Preview</h1></p>
                                    <div className="w-full h-[300px] border rounded-lg">
                                        <AvatarPreview
                                            avatarUrl={avatarData.avatar_id}
                                        />
                                    </div>
                                </div>

                            ) : (
                                <p className="text-gray-500">Enter an Avatar ID to see preview</p>
                            )}
                        </CardContent>
                    </Card>
                </div>

                {/* Submit button below */}
                <div className="mt-6">
                    <button
                        type="submit"
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                    >
                        Save Avatar
                    </button>
                </div>
            </form>
            </div>
        </DashboardLayout>
    );
}